<div id="progress" [ngClass]="{'loading': isBusy}">
    <p *ngIf=isBusy>
        {{taskStatus}}
    </p>
</div>